import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  selector: 'app-address-info-mobile',
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.scss'],
})
export class AddressInfoMobileComponent implements OnInit {
  @Output() handleConfirm = new EventEmitter();

  @Output() goBack = new EventEmitter();

  @Input() supplier: any;

  @Input() pickupDetailsForm: any;

  @Input() pickupDetailsValidation: any;

  @Input() additionalDetailsForm: any;

  @Input() additionalDetailsValidation: any;

  readonly maxCharacters: number = 250;

  characterCount: number = 0;

  ngOnInit(): void {
    this.updateCharacterCount();
  }

  updateCharacterCount(): void {
    const additionalDetailsControl = this.additionalDetailsForm.get('additionalDetails');
    if (additionalDetailsControl) {
      this.characterCount = additionalDetailsControl?.value?.length | 0;
    }
  }
}
